

const agentData = require('./agents')
const loggedInData = require('./login')
const splitTestData = require('./splitTests')

const reducers = {
  loggedInData,
  agentData,
  splitTestData
}

module.exports = reducers
